<template>
  <section class="train-search background">
    <div class="container">
      <div class="content-wrapper">
        <div class="content">
          <!--h1>Rozkład jazdy <span class="company">Zakotane Railway</span></h1-->
          <h1 class="main-title">Wyszukaj połączenie i kup bliet</h1>
          <h2 class="desc">
            Oferujemy atrakcyjne połączenia na liniach
            <span class="desc-cities">Zakopane - Kraków</span> oraz
            <span class="desc-cities">Rzeszów - Przemyśl</span>
          </h2>
          <form class="train-search-form" @submit.prevent="searchRoutes">
            <div class="inputs-block">
              <div class="station-params">
                <StationSelect
                  :stationID="searchParams.stationFromID"
                  :stationsList="stations"
                  @stationSelected="station => stationSelected(station, 'from')"
                  :class="{invalid: !stationFromValid}"
                  input_name="station-from"
                  input_placeholder="Wyjazd z..."
                  input_title="Wpisz nazwę stacji odjazdu"
                />
                <div class="swap-stations">
                  <button type="button" title="Zamień stacje" @click="reverseStations">
                    <i class="fas fa-exchange-alt nomargin"></i>
                  </button>
                </div>
                <StationSelect
                  :stationID="searchParams.stationToID"
                  :stationsList="stations"
                  @stationSelected="station => stationSelected(station, 'to')"
                  :class="{invalid: !stationToValid}"
                  input_name="station-to"
                  input_placeholder="Przyjazd do..."
                  input_title="Wpisz nazwę stacji przyjazdu"
                />
              </div>
              <div class="datetime-params">
                <div class="input-wrapper">
                  <label for="search-date" class="input-title">Data</label>
                  <input
                    type="date"
                    name="search-date"
                    id="search-date"
                    class="search-date"
                    title="Podaj datę odjazdu lub przyjazdu"
                    autocomplete="off"
                    required
                    v-model="searchParams.date"
                  >
                </div>
                <div class="input-wrapper">
                  <label for="search-time" class="input-title">Godzina</label>
                  <input
                    type="time"
                    name="search-time"
                    id="search-time"
                    class="search-time"
                    title="Podaj godzinę odjazdu lub przyjazdu"
                    autocomplete="off"
                    required
                    v-model="searchParams.time"
                  >
                </div>
              </div>
            </div>
            <div class="settings">
              <div class="departure-setting">
                <a
                  :class="{'selected': searchParams.departure}"
                  @click="searchParams.departure = true"
                >Odjazd</a>
                <a
                  :class="{'selected': !searchParams.departure}"
                  @click="searchParams.departure = false"
                >Przyjazd</a>
              </div>
              <div class="train-categories">
                <TrainCategory
                  v-for="category in trainCategories"
                  :key="category.id"
                  :category="category"
                  :selected="categorySelected(category.id)"
                  @selectionChanged="selected => trainCategoryChanged(category.id, selected)"
                />
              </div>
            </div>
            <div class="search-btn-ctr">
              <button type="submit" class="search-btn" title="Kliknij, aby wyszukać połączenia">
                <i class="fas fa-search"></i>Szukaj
              </button>
            </div>
            <div ref="scroolHandle"></div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { isNull } from 'util';
import StationSelect from '../controls/StationSelect.vue';
import TrainCategory from '../controls/TrainCategory.vue';

import storeMixins from '../mixins/storeMixins';
import findMixins from '../mixins/findMixins';

import cloneObject from '../helpers/cloneObject';
import updatePageTitle from '../helpers/updatePageTitle';

export default {
  name: 'TrainSearch',
  components: {
    StationSelect,
    TrainCategory,
  },
  mixins: [storeMixins, findMixins],
  data() {
    return {
      stationFromValid: true,
      stationToValid: true,
    };
  },
  computed: {
    categorySelected() {
      // zwraca funkcję
      return categoryID => this.searchParams.trainCategories.includes(categoryID);
    },
    isSearching() {
      return this.$store.state.search.isSearching;
    },
  },
  watch: {
    isSearching() {
      if (this.isSearching) {
        this.$scrollTo(this.$refs.scroolHandle);
      }
    },
  },
  created() {
    updatePageTitle('Wyszukiwanie połączeń');

    // na start wszystkie dostępne kategorie pociągów
    this.setAllTrainCategories();
  },
  mounted() {
    // zrestartuj stan wyboru stacji
    this.stationFromValid = true;
    this.stationToValid = true;
  },
  beforeRouteUpdate(to, from, next) {
    updatePageTitle('Wyszukiwanie połączeń');

    next();
  },
  methods: {
    setAllTrainCategories() {
      this.$store.commit(
        'search/updateTrainCategories',
        this.trainCategories.map(category => category.id),
      );
    },
    stationSelected(station, target) {
      if (target === 'from') {
        this.$store.commit('search/updateStationFrom', station);
        this.stationFromValid = !isNull(station);
      } else if (target === 'to') {
        this.$store.commit('search/updateStationTo', station);
        this.stationToValid = !isNull(station);
      }
    },
    updateStationsValidity() {
      const same = this.searchParams.stationFromID === this.searchParams.stationToID;

      this.stationFromValid = !same && !isNull(this.searchParams.stationFromID);
      this.stationToValid = !same && !isNull(this.searchParams.stationToID);
    },
    reverseStations() {
      const from = this.searchParams.stationFromID;
      const to = this.searchParams.stationToID;

      this.$store.commit('search/updateStationFrom', to);
      this.$store.commit('search/updateStationTo', from);
    },
    trainCategoryChanged(categoryID, selected) {
      const categ = cloneObject(this.searchParams.trainCategories);
      const index = categ.findIndex(item => item === categoryID);
      const added = index > -1;

      if (selected && !added) {
        categ.push(categoryID);
      } else if (!selected && added) {
        categ.splice(index, 1);
      }

      this.$store.commit('search/updateTrainCategories', categ);
    },
    searchRoutes() {
      this.updateStationsValidity();

      if (!this.stationFromValid || !this.stationToValid) return;

      let catgs = this.searchParams.trainCategories;

      // jeśli brak zaznaczonych kategorii, zaznacz je z powrotem
      if (catgs.length === 0) {
        this.setAllTrainCategories();
        catgs = this.searchParams.trainCategories;
      }

      const catgsNames = catgs.map(id => this.getTrainCategory(id).name);

      // this.$store.dispatch('search/searchTrains');

      this.$router.push({
        name: 'SearchResults',
        params: {
          from: this.getStationById(this.searchParams.stationFromID).name,
          to: this.getStationById(this.searchParams.stationToID).name,
          date: this.searchParams.date,
          time: this.searchParams.time,
          departure: this.searchParams.departure.toString(), // bool to string
          categories: catgsNames.join(),
        },
      });
    },
  },
};
</script>

<style scoped>
.train-search {
  min-height: 500px;
}

.content-wrapper {
  height: 500px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.content {
  margin: 0 auto;
}

h1.main-title {
  font-size: 45px;
  color: #fff;
  text-align: center;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  margin: 0 0 20px;
}

h2.desc {
  font-size: 20px;
  color: #fff;
  text-align: center;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.7);
  font-weight: 400;
  margin: 0 0 60px;
}

.desc-cities {
  font-weight: 600;
  background-color: var(--color-main);
  padding: 2px 7px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  border-radius: 3px;
}

form input,
form input:focus {
  outline: none;
}

form.train-search-form .input-block {
  display: flex;
  flex-flow: column wrap;
}

form.train-search-form .input-wrapper {
  /*background-color: #fff;
    border: 1px solid var(--color-main);*/
  background-color: rgba(255, 255, 255, 0.6);
  box-shadow: 0 0 15px 10px rgba(0, 0, 0, 0.3);
  border: none;
  border-radius: 4px;
  color: #444;
}

/*form.train-search-form .input-block station-params,
form.train-search-form .input-block datetime-params*/
form.train-search-form .inputs-block > div {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  margin-bottom: 20px;
}

form.train-search-form .inputs-block .station-params .swap-stations {
  margin: 0 15px;
  display: flex;
  align-items: center;
}

form.train-search-form .inputs-block .station-params .swap-stations button {
  font-size: 23px;
  padding: 5px 10px;
  border-radius: 3px;
}

form.train-search-form .inputs-block .datetime-params input {
  /*min-width: 150px; */
  min-width: 158px;
  padding: 0 10px 5px;
}

form.train-search-form .input-wrapper {
  display: flex;
  flex-flow: column nowrap;
  width: 150px;
}

form.train-search-form .input-wrapper:first-of-type {
  margin-right: 73px;
}

form.train-search-form .input-wrapper label {
  color: #444;
  font-size: 13px;
  padding: 4px 0 5px;
  text-align: center;
  font-weight: 300;
}

form.train-search-form .input-wrapper input {
  background: none;
  border: none;
}

/* todo: na sztywno przesunięcie, tylko dla fv */
/*form.train-search-form .input-wrapper .search-date {
  position: relative;
  left: 12px;
}*/

form.train-search-form .input-wrapper .search-time {
  padding-left: 48px !important;
}

form.train-search-form .settings {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  margin-bottom: 30px;
}

form.train-search-form .settings .departure-setting {
  display: flex;
  justify-content: flex-end;
  width: 50%;
  padding-right: 36px;
}

form.train-search-form .settings .departure-setting a {
  padding: 0 15px 5px;
  color: #fff;
  font-size: 20px;
}

form.train-search-form .settings .departure-setting a:hover,
form.train-search-form .settings .departure-setting a:focus {
  color: var(--color-main);
}

form.train-search-form .settings .departure-setting a:focus {
  outline: none;
}

form.train-search-form .settings .departure-setting a.selected {
  border-bottom: 2px solid var(--color-main);
}

form.train-search-form .settings .train-categories {
  display: flex;
  justify-content: left;
  width: 50%;
  padding-left: 36px;
}

form.train-search-form
  .settings
  .train-categories
  .train-category:not(:last-of-type) {
  margin-right: 10px;
}

form.train-search-form button.search-btn {
  display: block;
  padding: 10px 20px;
  margin: 0 auto;
  text-transform: uppercase;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}
</style>
